




































import { defineComponent, computed } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import { RepaymentModelToLabel } from '@/po/ProductResult';
import RepayPlanList from '../RepayPlanList/index.vue';
import InfoItem from '../InfoItem/index.vue';
import type { RepayDialogDataType } from '../../types';

export default defineComponent({
  components: {
    RepayPlanList,
    InfoItem,
  },
  props: {
    data: {
      type: Object as PropType<RepayDialogDataType>,
      default: () => ({}),
      required: true,
    },
  },
  setup(props: {
    data: RepayDialogDataType;
  }) {
    /** 格式化金额为两位小数 */
    const formatAmount = (value: number | string) => {
      const num = Number(value);
      return num.toFixed(2);
    };

    /** 还款总期数 */
    const totalPeriod = computed(() => props.data?.loanCalcList?.length || 0);

    /** 当前还款方式 */
    const currentRepayment = computed(() => {
      const { repaymentModel = [] } = props.data;
      return RepaymentModelToLabel[repaymentModel[0]] || '等额本息';
    });

    /** 将 debtConsultingFee 映射到 shouldPayAmount，让 RepayPlanList 展示 */
    const mappedLoanCalcList = computed(() => (props.data.loanCalcList || []).map((item) => ({
      ...item,
      periodLoanRelatedAmount: formatAmount(item.debtConsultingFee || 0),
    })));

    return {
      formatAmount,
      totalPeriod,
      currentRepayment,
      mappedLoanCalcList,
    };
  },
});
